import React from 'react';

import './ContentPage.css';
import { Box, Typography } from '@mui/material';
import { AccordionData } from '../AccordionData';
import { ButtonBack } from '../ButtonBack';

export function ContentPage() {
  return (
    <Box display="flex" height="80vh">
      <Box className="contentPage">
        <Typography
          className="headerContent"
          variant="h4"
          component="h1"
          margin="15px 0px"
          sx={{
            fontWeight: 700,
            color: '#0c326f',
            fontFamily: 'Raleway',
          }}
        >
          Perguntas frequentes
        </Typography>

        <AccordionData />

        <ButtonBack />
      </Box>
    </Box>
  );
}
